(function(Results) {
    'use strict';

    Results.container = false;

    Results.filterCountry = false;
    Results.filterBusinessLine = false;

    Results.filters = {
        'country': 0,
        'businessLine': 0
    };

    Results.initSearch = function() {
        // ensure everything we need can be found
        Results.container = $('.js-result-container');

        if (Results.container.length === 0) {
            return; // we are not on an results page
        }

        Results.filterBusinessLine = $('.js-result-filter-business-line');
        Results.filterCountry = $('.js-result-filter-country');

        if (Results.filterBusinessLine.length === 0 || Results.filterCountry.length === 0) {
            throw 'search missing result filters';
        }

        Results.setResultsList();

        // set change event filters
        Results.filterBusinessLine.on('change', Results.doSearch);
        Results.filterCountry.on('change', Results.doSearch);
    };

    Results.setResultsList = function() {
        Results.list = Results.container.find('.js-result');
    };

    Results.doSearch = function() {
        Results.setFilterValues();

        var showResult = function(result) {
            var businessLine = result.data('business-line');
            var country = result.data('country');

            var returnValue = true;
            var matchBusinessLine = true;
            var matchCountry = true;

            if (Results.filters.businessLine !== '' && Results.filters.businessLine > 0) {
                matchBusinessLine = businessLine == Results.filters.businessLine;
            }

            if (Results.filters.country !== '' && Results.filters.country > 0) {
                matchCountry = country == Results.filters.country;
            }

            if (!matchCountry || !matchBusinessLine) {
                returnValue = false;
            }

            return returnValue;
        };

        $.each(Results.list, function() {
            var result = $(this);

            // depending on the result of the showResult, we must
            // hide the parent of the result and not the result itself
            // this is because we do not want open spaces in the result list
            if (showResult(result)) {
                result.parent().show();
            } else {
                result.parent().hide();
            }
        });
    };

    Results.setFilterValues = function() {
        Results.filters.country = Results.filterCountry.data('country-id');
        Results.filters.businessLine = Results.filterBusinessLine.val();
    };

})(window.Way2web.Results = window.Way2web.Results || {});
